import React from 'react'
import { FormContainer, Input, Label, TextArea } from './styledComponents'

const CoverLetterForm = ({ formData, setFormData }) => {
  const handleChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  return (
    <FormContainer>
      <Label>Your Name</Label>
      <Input name="name" value={formData.name} onChange={handleChange} />

      <Label>Role You're Applying For</Label>
      <Input name="role" value={formData.role} onChange={handleChange} />

      <Label>Key Skills / Achievements</Label>
      <TextArea name="skills" value={formData.skills} onChange={handleChange} />
    </FormContainer>
  )
}

export default CoverLetterForm
